module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements and sources")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART 1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("THE TRAVELLING POST OFFICE")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("Chapter 1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Mail by Rail I")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The apparatus")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3"), _c('span', {
    staticClass: "space"
  }, [_vm._v("TPO services")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4"), _c('span', {
    staticClass: "space"
  }, [_vm._v("TPO rolling stock")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Accidents")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Accidents – claims for damages")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART 2"), _c('span', {
    staticClass: "space"
  }, [_vm._v("THE POST OFFICE (LONDON) RAILWAY")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Mail by Rail II")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Operations, and transition to Mail Rail")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Bag Tenders")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Precedents for replacing short carriages with longer ones and the apportionment of cost")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3"), _c('span', {
    staticClass: "space"
  }, [_vm._v("LNWR TPO Stock Allocations – 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 4"), _c('span', {
    staticClass: "space"
  }, [_vm._v("West Coast Joint Stock Allocations – 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 5"), _c('span', {
    staticClass: "space"
  }, [_vm._v("TPO Rolling Stock Allocations – 1937")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Appendix06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 6"), _c('span', {
    staticClass: "space"
  }, [_vm._v("West Coast Joint Stock postal vehicles")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Appendix07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 7"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Working the apparatus")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Appendix08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 8"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Postmarks, instruction marks, the late fee and collectibles")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Appendix09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 9"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Non-fatal accidents")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Appendix10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 10"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Sorting carriage repainting 1986-8")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Appendix11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 11"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Extant pre-nationalisation TPO vehicles")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 12"), _c('span', {
    staticClass: "space"
  }, [_vm._v("BR Mk 1 TPO rolling stock acquired for heritage or other uses")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 13"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Royal Mail Class 325 trains")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Appendix14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 14"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Self-propelled railcars used to carry bulk mail and parcels")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 15"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Post Office (London) Railway construction estimates 1913")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 16"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Post Office (London) Railway expenditure to 31 March 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Appendix17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 17"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Post Office (London) Railway technical data")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Appendix18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 18"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Post Office (London) Railway rolling stock acquired by heritage railways")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Appendix19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 19"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Post Office (London) Railway and Mail Rail image addendum")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Contrast in rolling stock styles on the Post Office (London) Railway.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0